// 2026-06-30 - FormuLearning - 관리자 외부 API 로그 조회 API 호출 (이슈 #30)
// 2026-09-26 수정 - 이슈 #95 단계 3-5: `usageTimeline` 삭제(`ADM-STAT-03` 폐기).
// 파일 위치: frontend/src/api/admin.ts

import client from './client'
import type { ApiResponse } from '../types/api'
import type {
  ApiIntegration,
  AdminUserManage,
  UserCreatePayload,
  UserUpdatePayload,
  AdminProjectRef,
  CallStatsRow,
  CallLog,
  CallLogDetail,
  CallLogPage,
  CallListFilters,
  UsageOperation,
  UsageProject,
  OperationCatalogItem,
  OperationLogPage,
  OperationListFilters,
} from '../types/admin'

export async function listIntegrations(): Promise<ApiIntegration[]> {
  const { data } = await client.get<ApiResponse<{ items: ApiIntegration[] }>>('/admin/api-integrations')
  return data.data!.items
}

// 관리 목록(AdminUserManage) — 드롭다운 소비처는 AdminUserRef 필드만 사용(상위 집합).
export async function listAdminUsers(): Promise<AdminUserManage[]> {
  const { data } = await client.get<ApiResponse<{ items: AdminUserManage[] }>>('/admin/users')
  return data.data!.items
}

export async function createUser(payload: UserCreatePayload): Promise<AdminUserManage> {
  const { data } = await client.post<ApiResponse<AdminUserManage>>('/admin/users', payload)
  return data.data!
}

export async function updateUser(id: string, payload: UserUpdatePayload): Promise<AdminUserManage> {
  const { data } = await client.patch<ApiResponse<AdminUserManage>>(`/admin/users/${id}`, payload)
  return data.data!
}

export async function deactivateUser(id: string): Promise<AdminUserManage> {
  const { data } = await client.delete<ApiResponse<AdminUserManage>>(`/admin/users/${id}`)
  return data.data!
}

export async function listAdminProjects(): Promise<AdminProjectRef[]> {
  const { data } = await client.get<ApiResponse<{ items: AdminProjectRef[] }>>('/admin/projects')
  return data.data!.items
}

export interface StatsParams {
  bucket?: 'day' | 'week' | 'month'
  from?: string
  to?: string
  api_id?: string
  provider?: string
}

export async function getCallStats(params: StatsParams = {}): Promise<CallStatsRow[]> {
  const { data } = await client.get<ApiResponse<{ items: CallStatsRow[] }>>('/admin/api-calls/stats', { params })
  return data.data!.items
}

export async function listCalls(filters: CallListFilters = {}): Promise<CallLogPage> {
  const { data } = await client.get<ApiResponse<CallLogPage>>('/admin/api-calls', { params: filters })
  return data.data!
}

export async function getCallDetail(id: string): Promise<CallLogDetail> {
  const { data } = await client.get<ApiResponse<CallLogDetail>>(`/admin/api-calls/${id}`)
  return data.data!
}

// --- 오퍼레이션 정의·실행 내역 (이슈 #32) ---

export async function listOperationCatalog(): Promise<OperationCatalogItem[]> {
  const { data } = await client.get<ApiResponse<{ items: OperationCatalogItem[] }>>('/admin/operation-catalog')
  return data.data!.items
}

export async function listOperations(filters: OperationListFilters = {}): Promise<OperationLogPage> {
  const { data } = await client.get<ApiResponse<OperationLogPage>>('/admin/operations', { params: filters })
  return data.data!
}

// --- 사용/운영 통계 (이슈 #32) ---

export async function usageOperations(projectId?: string): Promise<UsageOperation[]> {
  const { data } = await client.get<ApiResponse<{ items: UsageOperation[] }>>('/admin/usage/operations', {
    params: projectId ? { project_id: projectId } : {},
  })
  return data.data!.items
}

export async function usageProjects(): Promise<UsageProject[]> {
  const { data } = await client.get<ApiResponse<{ items: UsageProject[] }>>('/admin/usage/projects')
  return data.data!.items
}

export type { CallLog }
